module.exports = __webpack_public_path__ + "static/media/pyme-innovadora.ef3cacf3.svg";